import IconCalendarLeftArrow from "@/shared/components/generic/icons/IconCalendarLeftArrow.tsx";
import IconWatch from "@/shared/components/generic/icons/IconWatch.tsx";
import IconGraph from "@/shared/components/generic/icons/IconGraph.tsx";
import type { RecapTableRow } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/recap-table/RecapTableRow.ts";

interface RecapTableController {
  rows: RecapTableRow[];
}

const rows: RecapTableRow[] = [
  {
    mode: "PREVIOUS_YEAR",
    labelKey: "timeManagement.analysis.daySummaryMode.PREVIOUS_YEAR",
    Icon: IconCalendarLeftArrow,
  },
  {
    mode: "FORECAST",
    labelKey: "timeManagement.analysis.daySummaryMode.FORECAST",
    Icon: IconWatch,
  },
  {
    mode: "TREND",
    labelKey: "timeManagement.analysis.daySummaryMode.TREND",
    Icon: IconGraph,
  },
];

export function useRecapTable(): RecapTableController {
  return {
    rows,
  };
}
